module.exports = __webpack_public_path__ + "03788c78516b70517cb727267f6746a3.svg";